import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';
import { NzShareModule } from '../../nz/nz-share.module';
import { UIIconComponent } from "./ui-icon.component";
import { UiIconBtnComponent } from "./ui-icon-btn/ui-icon-btn.component";

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        TextMaskModule,
        NzShareModule,
    ],
    declarations: [UIIconComponent, UiIconBtnComponent],
    exports: [UIIconComponent, UiIconBtnComponent],
})
export class UIIconModule {}
